import { Card, Col, Form, Row } from 'react-bootstrap';
import { faBuilding, faGlobe } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { ProfileData } from './DataDefinitions';
import classNames from 'classnames';
interface CompanyInfoProps {
  profile: ProfileData;
  className?: string;
  onProfileChange: (name: string, value: any) => void;
}

const CompanyInfo = ({ profile, className, onProfileChange }: CompanyInfoProps) => {
  const { t } = useTranslation();

  // Function to handle input changes
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    onProfileChange(name, value);
  };

  return (
    <Card className={classNames(className, 'border border-light')}  >
      <Card.Body>
        <h4 className="mb-4">{t("CompanyInfo.company_info")}</h4>
        <Row className="g-3">
          <Col xs={12} sm={6}>
            <div className="form-icon-container">
              <Form.Floating>
                <Form.Control
                  id="your_department"
                  type="text"
                  placeholder={t("CompanyInfo.placeholder.your_department")}
                  className="form-icon-input"
                  value={profile.company_department}
                  name="company_department"
                  onChange={handleInputChange}
                />
                <label htmlFor="companyName" className="form-icon-label text-700">
                  {t("CompanyInfo.your_department")}
                </label>
              </Form.Floating>
              <FontAwesomeIcon
                icon={faBuilding}
                className="text-900 fs-9 form-icon"
              />
            </div>
          </Col>
          <Col xs={12} sm={6}>
            <div className="form-icon-container">
              <Form.Floating>
                <Form.Control
                  id="linkedin_url"
                  type="text"
                  placeholder={t("CompanyInfo.placeholder.linkedin_url")}
                  className="form-icon-input"
                  value={profile.linkedin_url}
                  name="linkedin_url"
                  onChange={handleInputChange}
                />
                <label htmlFor="linkedin_url" className="form-icon-label text-700">
                  {t("CompanyInfo.linkedin_url")}
                </label>
              </Form.Floating>
              <FontAwesomeIcon icon={faGlobe} className="text-900 fs-9 form-icon" />
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>

  );
};

export default CompanyInfo;
